import SolutionPageTemplate from "../components/SolutionPageTemplate";
import healthcare from "../Accets/healthcare.jpg";

export default function HealthcareSolutions() {
  return (
    <SolutionPageTemplate
      title="Healthcare Solutions"
      subtitle="Digitize healthcare payments, patient onboarding, insurance verification, and hospital financial operations with secure and compliant APIs."

      image={healthcare}

      challenges={[
        {
          title: "Delayed Insurance Claims",
          description:
            "Lengthy claim processing affects hospital cash flow and patient satisfaction.",
        },
        {
          title: "Manual Patient Verification",
          description:
            "Traditional onboarding processes increase waiting times and administrative workload.",
        },
        {
          title: "Complex Payment Collection",
          description:
            "Managing payments from patients, insurers, and third parties can be challenging.",
        },
        {
          title: "Regulatory Compliance",
          description:
            "Healthcare organizations must meet strict security and compliance standards for financial transactions.",
        },
      ]}

      features={[
        {
          title: "Digital Patient Onboarding",
          description:
            "Verify patients quickly with secure digital KYC and identity verification.",
        },
        {
          title: "Online Payment Collection",
          description:
            "Accept payments through UPI, cards, net banking, and digital wallets.",
        },
        {
          title: "Insurance Verification",
          description:
            "Verify insurance eligibility instantly through integrated APIs.",
        },
        {
          title: "Automated Billing",
          description:
            "Generate invoices and manage billing workflows efficiently.",
        },
        {
          title: "Instant Refunds",
          description:
            "Process cancelled appointments and refund requests automatically.",
        },
        {
          title: "Financial Analytics",
          description:
            "Track revenue, payment trends, and operational insights from one dashboard.",
        },
      ]}

      benefits={[
        {
          title: "Faster Patient Experience",
          description:
            "Reduce waiting time with seamless digital onboarding and payment processes.",
        },
        {
          title: "Improved Cash Flow",
          description:
            "Receive payments and insurance settlements faster with automated workflows.",
        },
        {
          title: "Enterprise Security",
          description:
            "Protect sensitive financial data with secure and compliant infrastructure.",
        },
        {
          title: "Scalable APIs",
          description:
            "Easily integrate with hospital management systems and healthcare platforms.",
        },
      ]}

      industries={[
        "Hospitals",
        "Diagnostic Labs",
        "Clinics",
        "HealthTech Platforms",
      ]}

      faqs={[
        {
          question: "Can hospitals collect payments online?",
          answer:
            "Yes. Our payment solutions support UPI, cards, net banking, and wallets for secure online collections.",
        },
        {
          question: "Can patient verification be automated?",
          answer:
            "Absolutely. Our APIs streamline patient onboarding with fast and secure identity verification.",
        },
        {
          question: "Do you support insurance verification?",
          answer:
            "Yes. Insurance verification APIs help hospitals validate patient coverage instantly.",
        },
        {
          question: "Is the platform secure?",
          answer:
            "Yes. Our infrastructure follows enterprise-grade security practices to protect sensitive healthcare payment data.",
        },
      ]}
    />
  );
}